export default __webpack_public_path__ + "static/media/newImg2.f8444c33.svg";